import { all } from "redux-saga/effects";
import { saga as assemblySaga } from "../ducks/assembly";
import { saga as authSaga } from "../ducks/auth";
import { saga as newsSaga } from "../ducks/news";

export default function*(): any {
  yield all([assemblySaga(), authSaga(), newsSaga()]);
}
